module.exports = __webpack_public_path__ + "img/xlsx.521dec4a.png";